var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTitle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Title",
    d: "M4.871,6.458c-0.911,0-1.65-0.739-1.65-1.651c0-0.911,0.739-1.65,1.65-1.65c0.912,0,1.65,0.739,1.65,1.65 C6.521,5.719,5.783,6.458,4.871,6.458 M22.373,11.496l-9.9-9.9c-0.396-0.396-0.947-0.638-1.551-0.638H3.221 c-1.221,0-2.2,0.979-2.2,2.2v7.7c0,0.605,0.242,1.155,0.649,1.552l9.89,9.9c0.407,0.396,0.958,0.647,1.562,0.647 s1.153-0.253,1.552-0.647l7.7-7.701c0.405-0.396,0.647-0.945,0.647-1.551C23.021,12.441,22.77,11.892,22.373,11.496z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTitle);
export default __webpack_public_path__ + "static/media/ic_title.75bacac42d34a4d1713665cfe8d3ac7a.svg";
export { ForwardRef as ReactComponent };